import {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ContentBody from "../common/content-body/ContentBody";
import {idEntityState, newRegistrationState, RFMContractorDataValueState} from "./model/state";
import {useRecoilState, useSetRecoilState} from "recoil";
import {FormikProvider} from "formik";
import RoyaltiesFeesManagementTab from "./tab/RoyaltiesFeesManagementTab";
import SectionHeader from "../../../util/component/SectionHeader";
import {useMutation} from "@tanstack/react-query";
import {getContractorById} from "./service/contractorSearch.actions";
import {setSnackbar} from "../../../util/state/globalAction";
import {snackbarTypes} from "../../../util/state/globalVariables";
import {GlobalContext} from "../../../util/state/GlobalContextProvider";
import CustomLoader from "../../../util/component/CustomLoader";

/**
 * Main Component for registration and insertion view, share same view, questo componente eredita Formik dal padre
 * All'avvio procedere al recupero dei dati, attraverso la selezione dei vari filetri nella view primcipale
 */
const Manager_RFM = () => {
    let initPage: number = 0; // init cycle

    const { dispatchGlobalData } = useContext(GlobalContext);
    const {t} = useTranslation(['network', 'translation']);
    // Use Location
    const {id} = useParams();
    const idContractorEntity: any = id;

    const setNewRegistration = useSetRecoilState(newRegistrationState);
    const [contractorDataState, setContractorDataState] = useRecoilState(RFMContractorDataValueState)
    const setIdEntity = useSetRecoilState(idEntityState);

    const [loading, setLoading] = useState<boolean>(true);

    /** Associate DMS */
    const contractorByIdMutation = useMutation(
        getContractorById,
        {
            onSuccess: (response: any) => {
                console.log("getContractorById");
                setIdEntity(response.id);
                if (response.royaltiesDued === "") {
                    response.royaltiesDued = 'NO';
                }
                setContractorDataState(response);
                setLoading(false);
            },
            onError: (error) => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t('translation:error.tryLater'),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
                setLoading(false);
            }
        });

    useEffect(() => {
        const ID = idContractorEntity;
        if(initPage === 0) {
            initPage = 1;
            if (ID === 'new') {
                setNewRegistration(true);
            }else{
                setIdEntity(ID)
                setNewRegistration(false);
                contractorByIdMutation.mutate({id: idContractorEntity} as any);
            }
        }
    }, [initPage, idContractorEntity]);

    useEffect(() => {
        if (!contractorDataState) {
            contractorByIdMutation.mutate({id: idContractorEntity} as any);
        }
    }, [contractorDataState]);

     if (loading) {
            return (
                 <CustomLoader loading />
            )
     }

    return (
        <>
            <SectionHeader title={t('contractorMng.managerRFM.title')}/>
            <ContentBody>
                <FormikProvider value={idContractorEntity}>
                    <RoyaltiesFeesManagementTab/>
                </FormikProvider>
            </ContentBody>

            {/* <CustomLoader loading={contractorByIdMutation.isLoading}/> */}
        </>
    );
}

export default Manager_RFM;
